import Vue from 'vue';
import VueRouter from 'vue-router';
//FIRESTORE
import auth from 'firebase/app';
import 'firebase/auth';
//HOME
import Home from '../views/home/Home.vue';
//TEAM
import Team from '../views/team/Team.vue';
//BLOG
import Blog from '../views/blog/Blog.vue';
import FullBlogPage from '../views/blog/components/FullBlogPage.vue';
//SUPPORT
import Support from '../views/support/Support.vue';
//LEGAL
import TermsConditions from '../views/legal/TermsConditions.vue';
import PrivacyPolicy from '../views/legal/PrivacyPolicy.vue';
import CustomerAgreement from '../views/legal/CustomerAgreement.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/market',
    name: 'Market',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/marketplace/MarketPlace.vue'),
    meta: { requiresAuth: true } //anything with this means a user must sign in to access
  },
  {
    path: '/team',
    name: 'Team', //TODO: standardize route name casing
    component: Team
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/post/:id',
    name: 'post',
    component: FullBlogPage
  },
  {
    path: '/support',
    name: 'support',
    component: Support
  },
  {
    path: '/terms-conditions',
    name: 'terms',
    component: TermsConditions
  },
  {
    path: '/privacy-policy',
    name: 'privacy',
    component: PrivacyPolicy
  },
  {
    path: '/customer-agreement',
    name: 'agreement',
    component: CustomerAgreement
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

//create route gaurd to check authentication
router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    router.replace('/register');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
